<template>
  <section class="p-1">
    <!-- <bread-crumb :bread-crumbs="['Compliance', 'List of Customers']" /> -->

    <v-card class="">
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 subtitle-1">{{ $route.query.filterBy }} Customers</div>
        <div>
          <bread-crumb :bread-crumbs="['Customers Filter']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <v-card-text>
        <loading
          :active="isloadagents"
          :is-full-page="false"
          :opacity="0.7"
          color="#ff6b00"
        />
        <v-row row-gutters class="mt-3">
          <v-spacer></v-spacer>
          <v-col cols="12" lg="4" xs="12">
            <v-btn depressed @click="downloadExcelsheet" color="primary" small
              ><v-icon small>mdi-file-excel-outline</v-icon>Export
            </v-btn>
          </v-col>
          <v-col cols="12" lg="4" xs="12"></v-col>
          <v-col cols="12" lg="4" xs="12">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Type here to filter the table data."
              single-line
              hide-details
              dense
              clearable
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>

      <v-data-table fixed-header  height="55vh"
        :headers="headers"
        :items="userList"
        :items-per-page="perPageSize"
        :search="search"
        loading-text="Please select the criteria to view records."
        no-data-text="Please select the criteria to view records."
        item-key="user_id"
        dense
      >
        <template v-slot:item.user_type="{ item }">
          <v-chip
            label
            small
            outlined
            :color="item.user_type == 'Individual' ? 'primary' : 'secondary'"
          >
            {{ item.user_type }}
          </v-chip>
        </template>

        <template v-slot:item.risk_status="{ item }">
          <v-chip
            v-if="item.risk_status"
            label
            small
            outlined
            :color="returnColor(item.risk_status)"
          >
            {{ item.risk_status }}
          </v-chip>
          <span v-else>{{ item.risk_status }}</span>
        </template>

        <template v-slot:item.Is_Negativelisted="{ item }">
          <v-icon :color="item.Is_Negativelisted === 2 ? 'red' : 'green'"
            >mdi-flag</v-icon
          >
        </template>

        <template v-slot:item.action="{ item }">
          <v-icon
            color="grey"
            title="View Details"
            class="mr-2"
            @click="nextpage(item)"
          >
            mdi-chevron-right-circle
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
  </section>
</template>

<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import Loading from "vue-loading-overlay";
import { mapGetters } from "vuex";
import userService from "@/services/UserService/userService.js";
export default {
  name: "Customer Filter",
  data: () => {
    return {
      itemsPerPage: "10",
      headers: [
        { text: "Customer ID", value: "user_id" },
        { text: "Customer Name", value: "name" },
        { text: "Customer Type", value: "user_type" },
        { text: "ID Number", value: "id_number" },
        { text: 'Partner', value: 'partner_name'},
        { text: "Nationality", value: "nationality" },
        { text: "Phone Number", value: "mobile_number" },
        { text: "Onboard Status", value: "kyc_status" },
        { text: "Account Status", value: "account_status" },
        { text: "Risk Status", value: "risk_status" },
        {
          text: "Navigation",
          value: "action",
          sortable: false,
          width: 150,
          align: "center",
        },
        // { text: 'Fraudulent', value: 'Is_Negativelisted', width: 80 }
        // { text: '', value: 'data-table-expand' },
      ],
      userList: [],
      tatalcustomerslist: [],
      search: "",
      listOfFilters: ["Customer Name", "Phone Number"],
      userSelectedFilter: "Customer Name",
      expanded: [],
      singleExpand: true,
      isloadagents: false,
      skip: 0, // Initial skip value
      limit: 1000, // Initial limit value
      perPageSize: window.innerWidth < 1600 ? 10 : 15,
      searchInputs: {
        fromdate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        todate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
      },
    };
  },
  components: {
    BreadCrumb,
    // listOverviewVue
    Loading,
  },
  computed: {
    ...mapGetters(["getpreviouspageState"]),
    isPreviousState() {
      return this.getpreviouspageState;
    },
  },
  mounted() {
    console.log("router", this.$route.query);
    if (this.$route.query) {
      if (this.$route.query.filterBy === "KYC Pending") {
        this.getRemitteList({
          customer_type: "ALL",
          kyc_status: "Pending",
          skip: this.skip,
          limit: this.limit,
        });
      } else if (this.$route.query.filterBy === "Today Register") {
        this.getRemitteList({
          customer_type: "ALL",
          from_date: this.searchInputs.fromdate,
          to_date: this.searchInputs.todate,
          skip: this.skip,
          limit: this.limit,
        });
      }
    }
  },
  methods: {
    async downloadExcelsheet() {
      if (this.userList) {
        this.exportToExcel(this.headers, this.userList, "List of customers");
      }
    },
    logComponentPath() {
      const currentPath = this.$route.path;
      console.log("Current Component Path:", currentPath);
    },
    validateFromDate(value) {
      if (value && this.searchInputs.to_date) {
        return (
          value <= this.searchInputs.to_date ||
          "From date cannot be later than To date"
        );
      }
      return true;
    },
    validateToDate(value) {
      if (value && this.searchInputs.from_date) {
        return (
          value >= this.searchInputs.from_date ||
          "To date cannot be earlier than From date"
        );
      }
      return true;
    },
    validateFromTxnDate(value) {
      if (value && this.searchInputs.txn_to_date) {
        return (
          value <= this.searchInputs.txn_to_date ||
          "From date cannot be later than To date"
        );
      }
      return true;
    },
    returnColor(val) {
      if (val.toLowerCase() == "medium") {
        return "orange";
      } else if (val.toLowerCase() == "high") {
        return "error";
      } else if (val.toLowerCase() == "low") {
        return "success";
      }
      return;
    },
    validateToTxnDate(value) {
      if (value && this.searchInputs.txn_from_date) {
        return (
          value >= this.searchInputs.txn_from_date ||
          "To date cannot be earlier than From date"
        );
      }
      return true;
    },
    isFieldClearable(fieldName) {
      return (
        this.searchInputs[fieldName] !== "" &&
        this.searchInputs[fieldName] !== null
      );
    },
    clear() {
      for (const fieldName in this.searchInputs) {
        this.searchInputs[fieldName] = "";
      }
    },

    // nextPage() {
    //   this.skip += this.limit; // Increase skip value by the current limit
    //   this.getRemitteList(); // Fetch the next page of results
    // },
    async getRemitteList(params) {
      this.isloadagents = true;
      console.log("rrr", this.searchInputs.customer_type);
      try {
        const response = await userService.getRemittenceList(params);
        if (response.status === 200) {
          this.isloadagents = false;
          this.userList = response.data.data;
        } else {
          this.isloadagents = false;
          // this.stoploader();
        }
      } catch (error) {
        this.isloadagents = false;
        // this.stoploader();
        console.error(error);
      }
    },

    async totalcuslist() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getTotalCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        console.log("totalcuslist", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async todayRegcuslist() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getTodayRegCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        console.log("todayRegcuslist", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async totalINDcuslist() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getTotalINDCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        console.log("totalINDcuslist", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async totalBUScuslist() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getTotalBUSCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        console.log("totalBUScuslist", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async totalRejectedcus() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getTotalBUSCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        // else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.totalRejectedcus();
        // }
        console.log("totalRejectedcus", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async INDRejectedcus() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getINDRejectCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        //  else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.INDRejectedcus();
        // }
        console.log("INDRejectedcus", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async BUSRejectedcus() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getBUSRejectCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        // else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.BUSRejectedcus();
        // }
        console.log("BUSRejectedcus", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async getAllaproval() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getBUSRejectCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        console.log("getAllaproval", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async getAllaprovalIND() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getApprovedINDCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        console.log("getAllaprovalIND", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async getAllaprovalBUS() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getApprovedBUSCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        console.log("getAllaprovalBUS", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async getAllhold() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getAllHoldCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        console.log("getAllhold", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async getAllholdIND() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getINDHoldCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        console.log("getAllholdIND", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async getAllholdBUS() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getBUSHoldCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        console.log("getAllholdBUS", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },

    getRiskLabel(riskVal) {
      if (riskVal >= 0 && riskVal <= 50) {
        return "Low risk";
      } else if (riskVal > 50 && riskVal <= 80) {
        return "Medium risk";
      } else {
        return "High risk";
      }
    },

    nextpage(item) {
      console.log("data ", item);
      this.$router.push({
        name: "List-Overview",

        query: {
          id: item.customer_id,
          login_id: item.login_id,
          customerid: item.customer_id,
          name: item.name,
          user_type: item.user_type,
          pin_no: item.txn_pin,
          risk_status: item.risk_status,
          percentage: item.risk_percentage,
        },
      });
      this.setCustomerRouteData({
        id: item.customer_id,
        customerid: item.customer_id,
        user_type: item.user_type,
        pin_no: item.txn_pin,
        risk_match_list: item.risk_match_list,
        percentage: item.risk_percentage,
      });
      console.log("item", item);
      console.log("customer_id", item.customer_id);
      sessionStorage.setItem("addBeneInd", item.login_id);
      sessionStorage.setItem("Benecustomer_id",item.customer_id)
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/global.scss";
.v-btn:not(.v-btn--round).v-size--default {
  height: 36px !important;
  min-width: 64px !important;
  padding: 0 16px !important;
}
.select-width {
  max-width: 60px;
}
</style>
